import React, { useState } from 'react'

//import { ApiCallPost} from "../ApiCall/ApiCall"
import { ApiCallPost } from '../../ApiCall/ApiCall';

import { useNavigate  } from "react-router-dom";


import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
//import  'primereact/resources/themes/lara-light-cyan/theme.css';

// value={value} onChange={(e) => setValue(e.target.value)}

export default function Login2( { setData } ) {
    const [inputValue,setInputValue] = useState( null )
    const [logError,setLogError] = useState( false )
    const [loggin,setLoggin] = useState( false )
    const [textError,setTextError] = useState( "")
    const [serverity,setSeverity] = useState( "error" )

    const navigate = useNavigate();


    function onSignUp()
    {
        navigate("/signup2" , { state : { clave : "supertools"} });
    }

    

    function onLogin() // Se esta solicitando ejecvutar el login
    {

        var user = document.getElementById( "username").value ;
        var password = inputValue ; // document.getElementById("password").value ;

        if ( user === "" || user === undefined || password === "" || password === undefined)
        {
            setTextError( "No se capturaron datos completos")
            setLogError( true )

            return ;
        }

        var data = {
            "email": user,
            "password": password,
            //"dTimeStamp": new Date()
        }

        console.log( "data = " , data )

        setLoggin( true ) ;

        ApiCallPost("login", data)
        .then( response =>{

          console.log( "Response = ", response )

          setLoggin( false )

          //navigate( '/loadexcel')

          if ( response.length === 0 )
          {
            setLoggin( false )

            setTextError( "Error en el login del usuario")
            setLogError( true )

            return 
          }
          setSeverity( "success")
          setTextError( "Bienvenido , registrado con exito")
          setLogError( true )

          //alert( "Bienvenido " + response[0].name )
          console.log( "Mandando cambar el setData")
          setData( response[0] )

        } )
        .catch( error => {
          console.log("Error = ", error)

          setLoggin( false )

          setTextError( "Error en el login del usuario")
          setLogError( true )

        })

    }

    function setTheInputValue( val )
    {
        //console.log( "val = " + val )
        setInputValue( val )
    }


  return (
    <div className='w-75' style={{margin:'auto'}}>
        <div className="card mt-5" >

        <div className="flex flex-columna md:flex-row">
            <div className="w-full md:w-5 flex flex-column align-items-center justify-content-center gap-3 py-5">
            <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                <label className="w-6rem">Username</label>
                <InputText id="username" type="text" onFocus={() => setLogError(false )}
                className="w-12rem" style={{border:'1px solid', borderColor : 'purple'}}/>
            </div>

            <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                <label className="w-6rem">Password</label>
                <Password className="w-12rem"  value={inputValue} onChange={(e) => setTheInputValue(e.target.value)} style={{border:'1px solid', borderColor : 'purple'}}
                    id='password' onFocus={() => setLogError(false )}
                    promptLabel="Teclee un Password" weakLabel="Muy simple" mediumLabel="Complejidad Mediana" strongLabel="Password Complejo" toggleMask />
            </div>

            <Button label="Login" icon="pi pi-user" onClick={onLogin}
                className="w-10rem mx-auto"></Button>

                {
                    logError && (
                        <div  className=" m-4">

                            <Message onClick={() => setLogError(false )} severity={serverity} text={textError}/>

                        </div>
                    )
                }

                {
                    loggin && (
                        <ProgressSpinner style={{width: '50px', height: '50px'}}/>
                    )
                }



            </div>


            <div className="w-full md:w-2">
                <Divider layout="vertical" className="hidden md:flex">
                    <b>O</b>
                </Divider>
            </div>

            <div className="w-full md:w-5 flex align-items-center  justify-content-center py-5">
                <Button  label="Nuevo Usuario" onClick={onSignUp}
                    icon="pi pi-user-plus" severity="success" className="w-10rem"></Button>
            </div>


        </div>
        </div>
    </div>
  )
}

//export default Login2 